module.exports = {

  productive: "#00AFEF",
  nonCore: "#1084B4",
  away: '#D8D9DC',
  offlineTime: '#ffba7d',

  outTime: "#46B3F3",
  inTime: '#1084B4',

  productiveList: "green",
  nonProductiveList: "red",
  xAxisColor: "#B9b9b9",
  timeLineChart: '#F9F9FB',
  primary: '#00AFEF',
  header: '#616161',
  productiveApp: '#5ED771',
  license: '#FF7F27',
  gray:"rgba(0, 0, 0, 0.48)",
  white:"#fff",
  label:"#9B9B9B"

  // timeLinebox:'#63D9CC'
};